import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Coins } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const HostDone = ({ order, onAnother }) => {
  const { t } = useLang();
  const s = t.pages.signup;
  const fill = (str) => str.replace("{name}", order.firstName).replace("{ref}", order.ref).replace("{email}", order.email);
  return (
    <div data-testid="signup-success" data-kind="host" className="mt-12 grid lg:grid-cols-12 gap-10 items-start">
      <div className="lg:col-span-5">
        <CheckCircle2 className="w-12 h-12 text-moss" />
        <div className="mt-4 text-xs font-extrabold uppercase tracking-[0.16em] text-amber-dark">{s.doneKicker}</div>
        <h3 data-testid="signup-success-title" className="mt-2 font-display text-3xl font-semibold text-ink">{fill(s.hostDoneTitle)}</h3>
        <p data-testid="host-done-body" className="mt-4 text-ink-muted leading-relaxed">{fill(order.client_email_sent === false ? s.hostDoneBodyNoMail : s.hostDoneBody)}</p>
        <button type="button" onClick={onAnother} data-testid="signup-another" className="mt-6 rounded-full border border-line px-5 py-2.5 font-bold text-ink hover:border-moss hover:text-moss transition-colors">
          {s.another}
        </button>
      </div>
      <div data-testid="host-next" className="lg:col-span-7 rounded-[1.75rem] border-2 border-moss/40 bg-paper p-6 md:p-8">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 rounded-full bg-moss/10 text-moss grid place-items-center"><Coins className="w-5 h-5" /></span>
          <h4 className="font-display text-2xl font-semibold text-ink">{s.hostNextTitle}</h4>
        </div>
        <ol className="mt-6 space-y-3">
          {s.hostNext.map((step, i) => (
            <li key={step} className="flex gap-3 text-ink">
              <span className="w-6 h-6 shrink-0 rounded-full bg-moss text-parchment text-xs font-extrabold grid place-items-center">{i + 1}</span>
              <span className="font-semibold">{step}</span>
            </li>
          ))}
        </ol>
        <Link to="/get-app" data-testid="host-done-get-app" className="mt-7 inline-flex items-center gap-2 rounded-full bg-moss hover:bg-moss-dark text-parchment px-6 py-3 font-extrabold transition-colors">
          {s.hostGetApp} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
